import { render, staticRenderFns } from "./ExaminationListTableRowGroup.vue?vue&type=template&id=1dab2db4&scoped=true&"
import script from "./ExaminationListTableRowGroup.vue?vue&type=script&lang=js&"
export * from "./ExaminationListTableRowGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationListTableRowGroup.vue?vue&type=style&index=0&id=1dab2db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab2db4",
  null
  
)

export default component.exports